module.exports = __webpack_public_path__ + "static/img/icon-04.034c9ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/how-to-books/icon-04.png
// module id = HU3A
// module chunks = 1